import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Sidebar } from './components/Sidebar';
import { JournalFeed } from './pages/JournalFeed';
import { LogProgress } from './pages/LogProgress';
import { SelfReflection } from './pages/SelfReflection';
import { MyMirror } from './pages/MyMirror';
import { Settings } from './pages/Settings';
import { Sample } from './pages/Sample';
import { useJournalAutoSave } from './lib/journal';
export function App() {
  useJournalAutoSave();
  return <Router data-id="element-0">
      <div className="flex min-h-screen bg-gray-50/50 font-sans" data-id="element-1">
        <Sidebar data-id="element-2" />
        <main className="flex-1 ml-64 overflow-y-auto" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<JournalFeed data-id="element-6" />} data-id="element-5" />
            <Route path="/log" element={<LogProgress data-id="element-8" />} data-id="element-7" />
            <Route path="/reflection" element={<SelfReflection data-id="element-10" />} data-id="element-9" />
            <Route path="/mirror" element={<MyMirror data-id="element-12" />} data-id="element-11" />
            <Route path="/sample" element={<Sample data-id="element-14" />} data-id="element-13" />
            <Route path="/settings" element={<Settings data-id="element-16" />} data-id="element-15" />
          </Routes>
        </main>
      </div>
    </Router>;
}